export enum PerfilEnum {

    USUARIO = 'Usuário',

    ADMIN_ATENDIMENTO = 'Admin. Atendimento',

    ADMIN = 'Administrador',

    ROOT = 'ROOT'
}

export namespace PerfilEnum {

    export function values() {
        return Object.keys(PerfilEnum).filter(
            (type) => isNaN(<any>type) && type !== 'values'
        );
    }
}